import api from "../api/axios"

export const checkAccess = async (descriptor) => {
  const res = await api.post("/access/check", { descriptor })
  return res.data
}

export const checkAccessQr = async (qrCode) => {
  const res = await api.post("/access/check", { qrCode })
  return res.data
}

export const getAccessLogs = async () => {
  const res = await api.get("/access/logs")
  return res.data
}

/** Journal d’accès pour l’écran TV (sans session), filtré par jeton de salle. */
export const getDisplayFeed = async (token) => {
  const res = await api.get("/access/display-feed", { params: { token } })
  return res.data
}

export const getGymDisplaySettings = async () => {
  const res = await api.get("/gym/display-settings")
  return res.data
}

export const regenerateDisplayToken = async () => {
  const res = await api.post("/gym/display-token/regenerate")
  return res.data
}

export const getGymAgentSettings = async () => {
  const res = await api.get("/gym/agent-settings")
  return res.data
}

export const regenerateAgentToken = async () => {
  const res = await api.post("/gym/agent-token/regenerate")
  return res.data
}

export const openDoor = async () => {
  const res = await api.post("/door/open")
  return res.data
}
